import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {matchPath, useLocation} from 'react-router-dom'

import {
  InnerSideNav,
  InnerSideNavItem,
} from '~/components/layout/sideNavs/innerSideNav/InnerSideNav'

type PartnerSidebarNavProps = {
  fullPath: string
  onClick: (id: string) => void
}

export const PartnerSidebarNav: React.FC<PartnerSidebarNavProps> = ({
  fullPath,
  onClick,
}) => {
  const {t} = useTranslation<string>()
  const location = useLocation()

  const navDataList = useMemo(
    () => [
      {id: 'profile', label: t('Profile')},
      {id: 'working-hours', label: t('Working hours')},
      {id: 'email-templates', label: t('Email templates')},
    ],
    [t],
  )

  const activeRouteId = useMemo(
    () =>
      navDataList
        .map(({id}) => matchPath(`${fullPath}${id}`, location.pathname) && id)
        .find((result) => !!result) || navDataList[0].id,
    [navDataList, fullPath, location.pathname],
  )

  return (
    <InnerSideNav>
      {navDataList.map((data) => (
        <InnerSideNavItem
          key={data.id}
          active={activeRouteId === data.id}
          onClick={() => onClick(data.id)}>
          {data.label}
        </InnerSideNavItem>
      ))}
    </InnerSideNav>
  )
}
